{
  "level": "mt04b",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt04b",
    "objects": "AREAS.E3:mt04b.e3",
    "mesh": "TREES.E3:mt04b.e3"
  },
  "spawn_point": {
    "position": [
      -710.8133685631666,
      -2742.67339637132,
      784.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -710.8133685631666,
      -2642.67339637132,
      784.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -871.5,
      -2857.0,
      760.0
    ],
    "bbox_max": [
      -567.0,
      -2625.0,
      830.0
    ],
    "vertex_count": 1002,
    "vertices": [
      [
        -682.0,
        -2818.2001953125,
        766.0
      ],
      [
        -658.0,
        -2818.2001953125,
        766.0
      ],
      [
        -713.0,
        -2818.2001953125,
        766.0
      ],
      [
        -689.0,
        -2818.2001953125,
        766.0
      ],
      [
        -744.0,
        -2818.2001953125,
        766.0
      ],
      [
        -720.0,
        -2818.2001953125,
        766.0
      ],
      [
        -775.0,
        -2818.2001953125,
        766.0
      ],
      [
        -751.0,
        -2818.2001953125,
        766.0
      ],
      [
        -806.0,
        -2818.2001953125,
        766.0
      ],
      [
        -782.0,
        -2818.2001953125,
        766.0
      ],
      [
        -808.0,
        -2730.0,
        760.0
      ],
      [
        -778.5,
        -2730.0,
        760.0
      ],
      [
        -685.5,
        -2730.0,
        760.0
      ],
      [
        -656.0,
        -2730.0,
        760.0
      ],
      [
        -685.5,
        -2730.0,
        760.0
      ],
      [
        -716.5,
        -2730.0,
        760.0
      ],
      [
        -747.5,
        -2730.0,
        760.0
      ],
      [
        -716.5,
        -2730.0,
        760.0
      ],
      [
        -778.5,
        -2730.0,
        760.0
      ],
      [
        -747.5,
        -2730.0,
        760.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        760.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        760.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        760.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        760.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        760.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        760.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        760.0
      ],
      [
        -871.5,
        -2715.0,
        760.0
      ],
      [
        -871.5,
        -2715.0,
        760.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        760.0
      ],
      [
        -840.5,
        -2708.11181640625,
        760.0
      ],
      [
        -838.5,
        -2708.11181640625,
        760.0
      ],
      [
        -838.5,
        -2708.11181640625,
        760.0
      ],
      [
        -839.0,
        -2707.51171875,
        760.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -654.0,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -654.0,
        -2633.0,
        766.0
      ],
      [
        -610.0,
        -2633.0,
        766.0
      ],
      [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      [
        -656.0,
        -2730.0,
        764.0001220703125
      ],
      [
        -656.0,
        -2730.0,
        760.0
      ],
      [
        -808.0,
        -2700.28564453125,
        766.0
      ],
      [
        -808.0,
        -2700.28564453125,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -808.0,
        -2728.199951171875,
        766.0
      ],
      [
        -808.0,
        -2730.0,
        760.0
      ],
      [
        -808.0,
        -2730.0,
        764.0001220703125
      ],
      [
        -812.4000244140625,
        -2633.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2667.0,
        766.0
      ],
      [
        -812.0,
        -2705.0,
        765.0
      ],
      [
        -812.0,
        -2701.0,
        765.0
      ],
      [
        -812.0,
        -2725.0,
        765.0
      ],
      [
        -812.0,
        -2705.0,
        765.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        765.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        765.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        765.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        765.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        765.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        765.0
      ],
      [
        -871.5,
        -2715.0,
        765.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        765.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        765.0
      ],
      [
        -871.5,
        -2715.0,
        765.0
      ],
      [
        -840.5,
        -2708.11181640625,
        765.0
      ],
      [
        -838.5,
        -2708.11181640625,
        765.0
      ],
      [
        -838.5,
        -2708.11181640625,
        765.0
      ],
      [
        -839.0,
        -2707.51171875,
        765.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        766.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        766.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        766.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        766.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        766.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        766.0
      ],
      [
        -871.5,
        -2715.0,
        766.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        766.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        766.0
      ],
      [
        -871.5,
        -2715.0,
        766.0
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        766.0
      ],
      [
        -825.0,
        -2708.5,
        766.0
      ],
      [
        -824.0,
        -2705.0,
        766.0
      ],
      [
        -821.5,
        -2700.0,
        766.0
      ],
      [
        -838.545654296875,
        -2708.05712890625,
        766.0
      ],
      [
        -839.0,
        -2707.51171875,
        766.0
      ],
      [
        -838.545654296875,
        -2708.05712890625,
        765.0
      ],
      [
        -824.0,
        -2705.0,
        766.0
      ],
      [
        -824.0,
        -2708.53271484375,
        765.0
      ],
      [
        -824.0,
        -2708.53271484375,
        766.0
      ],
      [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      [
        -824.0,
        -2719.10009765625,
        766.0
      ],
      [
        -824.0,
        -2725.0,
        766.0
      ],
      [
        -840.5,
        -2708.11181640625,
        766.0
      ],
      [
        -838.5,
        -2708.11181640625,
        766.0
      ],
      [
        -838.5,
        -2708.11181640625,
        766.0
      ],
      [
        -825.0,
        -2719.10009765625,
        766.0
      ],
      [
        -824.0,
        -2719.10009765625,
        766.0
      ],
      [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      [
        -825.0,
        -2710.89990234375,
        766.0
      ],
      [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      [
        -687.0,
        -2678.0,
        766.0
      ],
      [
        -687.0,
        -2688.0,
        766.0
      ],
      [
        -684.0,
        -2688.0,
        766.0
      ],
      [
        -684.0,
        -2678.0,
        766.0
      ],
      [
        -684.0,
        -2688.0,
        766.0
      ],
      [
        -687.0,
        -2688.0,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -777.0,
        -2688.0,
        766.0
      ],
      [
        -777.0,
        -2678.0,
        766.0
      ],
      [
        -777.0,
        -2688.0,
        766.0
      ],
      [
        -780.0,
        -2688.0,
        766.0
      ],
      [
        -718.0,
        -2678.0,
        766.0
      ],
      [
        -718.0,
        -2688.0,
        766.0
      ],
      [
        -715.0,
        -2688.0,
        766.0
      ],
      [
        -715.0,
        -2678.0,
        766.0
      ],
      [
        -715.0,
        -2688.0,
        766.0
      ],
      [
        -718.0,
        -2688.0,
        766.0
      ],
      [
        -749.0,
        -2678.0,
        766.0
      ],
      [
        -749.0,
        -2688.0,
        766.0
      ],
      [
        -746.0,
        -2688.0,
        766.0
      ],
      [
        -746.0,
        -2678.0,
        766.0
      ],
      [
        -746.0,
        -2688.0,
        766.0
      ],
      [
        -749.0,
        -2688.0,
        766.0
      ],
      [
        -808.0,
        -2730.0,
        766.0
      ],
      [
        -656.0,
        -2730.0,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        760.0
      ],
      [
        -778.5,
        -2760.0,
        760.0
      ],
      [
        -685.5,
        -2760.0,
        760.0
      ],
      [
        -656.0,
        -2760.0,
        760.0
      ],
      [
        -685.5,
        -2760.0,
        760.0
      ],
      [
        -716.5,
        -2760.0,
        760.0
      ],
      [
        -747.5,
        -2760.0,
        760.0
      ],
      [
        -716.5,
        -2760.0,
        760.0
      ],
      [
        -778.5,
        -2760.0,
        760.0
      ],
      [
        -747.5,
        -2760.0,
        760.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        760.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        760.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        760.0
      ],
      [
        -871.5,
        -2775.0,
        760.0
      ],
      [
        -871.5,
        -2775.0,
        760.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        760.0
      ],
      [
        -838.5,
        -2781.89990234375,
        760.0
      ],
      [
        -840.5,
        -2781.89990234375,
        760.0
      ],
      [
        -839.0,
        -2782.5,
        760.0
      ],
      [
        -838.5,
        -2781.89990234375,
        760.0
      ],
      [
        -656.0,
        -2761.800048828125,
        766.0
      ],
      [
        -656.0,
        -2804.39990234375,
        766.0
      ],
      [
        -656.0,
        -2760.0,
        760.0
      ],
      [
        -656.0,
        -2760.0,
        764.0001220703125
      ],
      [
        -808.0,
        -2789.71435546875,
        766.0
      ],
      [
        -808.0,
        -2789.71435546875,
        766.0
      ],
      [
        -808.0,
        -2804.39990234375,
        766.0
      ],
      [
        -808.0,
        -2761.800048828125,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        764.0001220703125
      ],
      [
        -808.0,
        -2760.0,
        760.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        765.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        765.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        765.0
      ],
      [
        -871.5,
        -2775.0,
        765.0
      ],
      [
        -871.5,
        -2775.0,
        765.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        765.0
      ],
      [
        -838.5,
        -2781.89990234375,
        765.0
      ],
      [
        -840.5,
        -2781.89990234375,
        765.0
      ],
      [
        -839.0,
        -2782.5,
        765.0
      ],
      [
        -838.5,
        -2781.89990234375,
        765.0
      ],
      [
        -819.5,
        -2790.0,
        766.0
      ],
      [
        -819.5,
        -2801.800048828125,
        766.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        766.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        766.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        766.0
      ],
      [
        -871.5,
        -2775.0,
        766.0
      ],
      [
        -871.5,
        -2775.0,
        766.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        766.0
      ],
      [
        -825.0,
        -2781.5,
        766.0
      ],
      [
        -836.8701171875,
        -2781.88818359375,
        766.0
      ],
      [
        -821.5,
        -2790.0,
        766.0
      ],
      [
        -824.0,
        -2785.0,
        766.0
      ],
      [
        -839.0,
        -2782.5,
        766.0
      ],
      [
        -838.5355834960938,
        -2781.942626953125,
        766.0
      ],
      [
        -838.5355834960938,
        -2781.942626953125,
        765.0
      ],
      [
        -824.0,
        -2781.46728515625,
        765.0
      ],
      [
        -824.0,
        -2785.0,
        766.0
      ],
      [
        -824.0,
        -2781.46728515625,
        766.0
      ],
      [
        -821.5,
        -2790.0,
        766.0
      ],
      [
        -819.5,
        -2790.0,
        766.0
      ],
      [
        -824.0,
        -2765.0,
        766.0
      ],
      [
        -824.0,
        -2770.89990234375,
        766.0
      ],
      [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      [
        -838.5,
        -2781.89990234375,
        766.0
      ],
      [
        -840.5,
        -2781.89990234375,
        766.0
      ],
      [
        -838.5,
        -2781.89990234375,
        766.0
      ],
      [
        -824.0,
        -2770.89990234375,
        766.0
      ],
      [
        -825.0,
        -2770.89990234375,
        766.0
      ],
      [
        -825.0,
        -2779.10009765625,
        766.0
      ],
      [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      [
        -718.0,
        -2802.0,
        766.0
      ],
      [
        -718.0,
        -2812.0,
        766.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -687.0,
        -2812.0,
        766.0
      ],
      [
        -684.0,
        -2812.0,
        766.0
      ],
      [
        -684.0,
        -2802.0,
        766.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -684.0,
        -2802.0,
        766.0
      ],
      [
        -656.0,
        -2804.39990234375,
        766.0
      ],
      [
        -715.0,
        -2812.0,
        766.0
      ],
      [
        -715.0,
        -2802.0,
        766.0
      ],
      [
        -718.0,
        -2802.0,
        766.0
      ],
      [
        -715.0,
        -2802.0,
        766.0
      ],
      [
        -749.0,
        -2802.0,
        766.0
      ],
      [
        -749.0,
        -2812.0,
        766.0
      ],
      [
        -746.0,
        -2812.0,
        766.0
      ],
      [
        -746.0,
        -2802.0,
        766.0
      ],
      [
        -749.0,
        -2802.0,
        766.0
      ],
      [
        -746.0,
        -2802.0,
        766.0
      ],
      [
        -777.0,
        -2812.0,
        766.0
      ],
      [
        -777.0,
        -2802.0,
        766.0
      ],
      [
        -808.0,
        -2804.39990234375,
        766.0
      ],
      [
        -780.0,
        -2802.0,
        766.0
      ],
      [
        -777.0,
        -2802.0,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        766.0
      ],
      [
        -656.0,
        -2760.0,
        766.0
      ],
      [
        -746.0,
        -2681.01904296875,
        766.0
      ],
      [
        -777.0,
        -2681.01904296875,
        766.0
      ],
      [
        -777.0,
        -2630.0,
        775.0
      ],
      [
        -777.0,
        -2633.0,
        790.0
      ],
      [
        -777.0,
        -2633.0,
        766.0
      ],
      [
        -777.0,
        -2630.0,
        775.0
      ],
      [
        -806.0,
        -2681.01904296875,
        766.0
      ],
      [
        -749.0,
        -2681.01904296875,
        766.0
      ],
      [
        -749.0,
        -2630.0,
        775.0
      ],
      [
        -749.0,
        -2633.0,
        790.0
      ],
      [
        -746.0,
        -2633.0,
        766.0
      ],
      [
        -746.0,
        -2630.0,
        775.0
      ],
      [
        -749.0,
        -2633.0,
        766.0
      ],
      [
        -749.0,
        -2630.0,
        775.0
      ],
      [
        -751.0,
        -2681.01904296875,
        766.0
      ],
      [
        -775.0,
        -2681.01904296875,
        766.0
      ],
      [
        -684.0,
        -2681.01904296875,
        766.0
      ],
      [
        -687.0,
        -2681.01904296875,
        766.0
      ],
      [
        -687.0,
        -2669.0,
        810.5
      ],
      [
        -684.0,
        -2669.0,
        810.5
      ],
      [
        -684.0,
        -2675.0,
        810.5
      ],
      [
        -687.0,
        -2675.0,
        810.5
      ],
      [
        -687.0,
        -2625.0,
        810.5
      ],
      [
        -684.0,
        -2625.0,
        810.5
      ],
      [
        -684.0,
        -2631.0,
        810.5
      ],
      [
        -687.0,
        -2631.0,
        810.5
      ],
      [
        -684.0,
        -2669.0,
        810.5
      ],
      [
        -687.0,
        -2669.0,
        810.5
      ],
      [
        -687.0,
        -2631.0,
        810.5
      ],
      [
        -684.0,
        -2631.0,
        810.5
      ],
      [
        -687.0,
        -2630.0,
        775.0
      ],
      [
        -687.0,
        -2633.0,
        766.0
      ],
      [
        -684.0,
        -2633.0,
        766.0
      ],
      [
        -684.0,
        -2630.0,
        775.0
      ],
      [
        -687.0,
        -2647.0,
        825.0
      ],
      [
        -684.0,
        -2647.0,
        825.0
      ],
      [
        -684.0,
        -2631.0,
        825.0
      ],
      [
        -687.0,
        -2631.0,
        825.0
      ],
      [
        -684.0,
        -2653.0,
        825.0
      ],
      [
        -687.0,
        -2653.0,
        825.0
      ],
      [
        -687.0,
        -2669.0,
        825.0
      ],
      [
        -684.0,
        -2669.0,
        825.0
      ],
      [
        -684.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -687.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -687.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -684.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -684.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -687.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -687.0,
        -2653.0,
        825.0
      ],
      [
        -684.0,
        -2653.0,
        825.0
      ],
      [
        -684.0,
        -2647.0,
        825.0
      ],
      [
        -687.0,
        -2647.0,
        825.0
      ],
      [
        -687.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -684.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -684.0,
        -2675.0,
        820.0
      ],
      [
        -687.0,
        -2675.0,
        820.0
      ],
      [
        -687.0,
        -2675.0,
        810.5
      ],
      [
        -684.0,
        -2675.0,
        810.5
      ],
      [
        -687.0,
        -2625.0,
        820.0
      ],
      [
        -684.0,
        -2625.0,
        820.0
      ],
      [
        -684.0,
        -2625.0,
        810.5
      ],
      [
        -687.0,
        -2625.0,
        810.5
      ],
      [
        -687.0,
        -2631.0,
        825.0
      ],
      [
        -684.0,
        -2631.0,
        825.0
      ],
      [
        -684.0,
        -2625.0,
        820.0
      ],
      [
        -687.0,
        -2625.0,
        820.0
      ],
      [
        -684.0,
        -2669.0,
        825.0
      ],
      [
        -687.0,
        -2669.0,
        825.0
      ],
      [
        -687.0,
        -2675.0,
        820.0
      ],
      [
        -684.0,
        -2675.0,
        820.0
      ],
      [
        -727.5,
        -2685.871826171875,
        810.5
      ],
      [
        -702.5,
        -2685.871826171875,
        810.5
      ],
      [
        -718.0,
        -2685.8173828125,
        810.0
      ],
      [
        -718.0,
        -2681.01904296875,
        766.0
      ],
      [
        -715.0,
        -2685.8173828125,
        810.0
      ],
      [
        -715.0,
        -2681.01904296875,
        766.0
      ],
      [
        -718.0,
        -2633.0,
        766.0
      ],
      [
        -718.0,
        -2630.0,
        775.0
      ],
      [
        -715.0,
        -2630.0,
        775.0
      ],
      [
        -715.0,
        -2633.0,
        766.0
      ],
      [
        -715.0,
        -2679.0,
        805.0
      ],
      [
        -718.0,
        -2679.0,
        805.0
      ],
      [
        -718.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -715.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -698.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -698.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -698.0,
        -2685.871826171875,
        810.5
      ],
      [
        -698.0,
        -2679.0,
        810.5
      ],
      [
        -689.0,
        -2681.01904296875,
        766.0
      ],
      [
        -713.0,
        -2681.01904296875,
        766.0
      ],
      [
        -732.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -732.0,
        -2679.0,
        810.5
      ],
      [
        -732.0,
        -2685.871826171875,
        810.5
      ],
      [
        -732.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -720.0,
        -2681.01904296875,
        766.0
      ],
      [
        -744.0,
        -2681.01904296875,
        766.0
      ],
      [
        -732.0,
        -2679.0,
        825.0
      ],
      [
        -732.0,
        -2687.998291015625,
        830.0
      ],
      [
        -732.0,
        -2687.453125,
        825.0
      ],
      [
        -698.0,
        -2687.453125,
        825.0
      ],
      [
        -698.0,
        -2687.998291015625,
        830.0
      ],
      [
        -698.0,
        -2679.0,
        825.0
      ],
      [
        -705.0,
        -2686.90771484375,
        820.0
      ],
      [
        -725.0,
        -2686.90771484375,
        820.0
      ],
      [
        -698.0,
        -2686.90771484375,
        820.0
      ],
      [
        -698.0,
        -2679.0,
        820.0
      ],
      [
        -732.0,
        -2679.0,
        820.0
      ],
      [
        -732.0,
        -2686.90771484375,
        820.0
      ],
      [
        -705.0,
        -2686.90771484375,
        820.0
      ],
      [
        -702.606201171875,
        -2685.915771484375,
        810.9035034179688
      ],
      [
        -698.0,
        -2685.915771484375,
        810.9035034179688
      ],
      [
        -698.0,
        -2679.0,
        816.6669311523438
      ],
      [
        -725.0,
        -2686.90771484375,
        820.0
      ],
      [
        -727.393798828125,
        -2685.915771484375,
        810.9035034179688
      ],
      [
        -732.0,
        -2679.0,
        816.6669311523438
      ],
      [
        -732.0,
        -2685.915771484375,
        810.9035034179688
      ],
      [
        -702.5,
        -2685.871826171875,
        810.5
      ],
      [
        -727.5,
        -2685.871826171875,
        810.5
      ],
      [
        -567.0,
        -2687.016845703125,
        821.0
      ],
      [
        -567.0,
        -2685.871826171875,
        810.5
      ],
      [
        -595.0,
        -2685.871826171875,
        810.5
      ],
      [
        -567.0,
        -2685.871826171875,
        810.5
      ],
      [
        -573.699951171875,
        -2655.50634765625,
        810.5
      ],
      [
        -573.699951171875,
        -2655.50634765625,
        810.5
      ],
      [
        -573.5,
        -2655.50634765625,
        810.5
      ],
      [
        -658.0,
        -2681.01904296875,
        766.0
      ],
      [
        -605.0,
        -2682.0,
        825.0
      ],
      [
        -637.0,
        -2682.0,
        825.0
      ],
      [
        -573.0,
        -2682.0,
        826.0
      ],
      [
        -571.7999877929688,
        -2682.0,
        825.0
      ],
      [
        -571.7999877929688,
        -2676.0,
        825.0
      ],
      [
        -567.0,
        -2675.0,
        825.0
      ],
      [
        -569.0,
        -2675.0,
        825.0
      ],
      [
        -599.3289184570312,
        -2687.671142578125,
        827.0
      ],
      [
        -608.5197143554688,
        -2687.671142578125,
        827.0
      ],
      [
        -633.4802856445312,
        -2687.671142578125,
        827.0
      ],
      [
        -642.6710815429688,
        -2687.671142578125,
        827.0
      ],
      [
        -608.5197143554688,
        -2687.671142578125,
        827.0
      ],
      [
        -633.4802856445312,
        -2687.671142578125,
        827.0
      ],
      [
        -605.0,
        -2682.0,
        825.0
      ],
      [
        -599.3289184570312,
        -2687.671142578125,
        827.0
      ],
      [
        -599.5469970703125,
        -2687.453125,
        825.0
      ],
      [
        -573.0,
        -2687.56201171875,
        826.0
      ],
      [
        -571.7999877929688,
        -2687.452880859375,
        825.0
      ],
      [
        -605.0,
        -2682.0,
        814.166748046875
      ],
      [
        -637.0,
        -2682.0,
        814.166748046875
      ],
      [
        -567.0,
        -2675.0,
        820.0000610351562
      ],
      [
        -573.5,
        -2675.0,
        820.0001220703125
      ],
      [
        -567.0,
        -2682.0,
        821.0
      ],
      [
        -571.7999877929688,
        -2682.0,
        825.0
      ],
      [
        -573.5,
        -2675.0,
        820.0001220703125
      ],
      [
        -573.5,
        -2676.0,
        819.1668090820312
      ],
      [
        -641.0354614257812,
        -2686.035400390625,
        812.0
      ],
      [
        -639.6002807617188,
        -2684.600341796875,
        812.0
      ],
      [
        -635.4397583007812,
        -2684.600341796875,
        812.0
      ],
      [
        -634.5786743164062,
        -2686.035400390625,
        812.0
      ],
      [
        -607.4213256835938,
        -2686.035400390625,
        812.0
      ],
      [
        -606.5602416992188,
        -2684.600341796875,
        812.0
      ],
      [
        -602.3997192382812,
        -2684.600341796875,
        812.0
      ],
      [
        -600.9645385742188,
        -2686.035400390625,
        812.0
      ],
      [
        -634.5786743164062,
        -2686.035400390625,
        812.0
      ],
      [
        -635.4397583007812,
        -2684.600341796875,
        812.0
      ],
      [
        -606.5602416992188,
        -2684.600341796875,
        812.0
      ],
      [
        -607.4213256835938,
        -2686.035400390625,
        812.0
      ],
      [
        -600.9645385742188,
        -2686.035400390625,
        812.0
      ],
      [
        -602.3997192382812,
        -2684.600341796875,
        812.0
      ],
      [
        -605.0,
        -2682.0,
        814.166748046875
      ],
      [
        -567.0,
        -2687.016845703125,
        821.0
      ],
      [
        -600.5,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -567.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -573.5,
        -2675.0,
        814.2000732421875
      ],
      [
        -573.5,
        -2675.0,
        814.2000732421875
      ],
      [
        -573.5,
        -2676.0,
        814.2000732421875
      ],
      [
        -700.5,
        -2829.999755859375,
        825.0
      ],
      [
        -698.0,
        -2829.999755859375,
        825.0
      ],
      [
        -733.0,
        -2829.999755859375,
        825.0
      ],
      [
        -700.5,
        -2829.999755859375,
        825.0
      ],
      [
        -698.0,
        -2829.999755859375,
        825.0
      ],
      [
        -610.0,
        -2829.999755859375,
        825.0
      ],
      [
        -746.0,
        -2812.0,
        825.0
      ],
      [
        -746.0,
        -2802.54541015625,
        825.0
      ],
      [
        -749.0,
        -2812.0,
        825.0
      ],
      [
        -749.0,
        -2802.54541015625,
        825.0
      ],
      [
        -777.0,
        -2812.0,
        825.0
      ],
      [
        -777.0,
        -2802.54541015625,
        825.0
      ],
      [
        -687.0,
        -2812.0,
        825.0
      ],
      [
        -687.0,
        -2802.54541015625,
        825.0
      ],
      [
        -684.0,
        -2812.0,
        825.0
      ],
      [
        -684.0,
        -2802.54541015625,
        825.0
      ],
      [
        -732.0,
        -2802.546875,
        825.0
      ],
      [
        -732.0,
        -2802.001708984375,
        830.0
      ],
      [
        -732.0,
        -2811.0,
        825.0
      ],
      [
        -698.0,
        -2811.0,
        825.0
      ],
      [
        -698.0,
        -2802.001708984375,
        830.0
      ],
      [
        -698.0,
        -2802.546875,
        825.0
      ],
      [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      [
        -702.5,
        -2804.128173828125,
        810.5
      ],
      [
        -638.0,
        -2827.099853515625,
        810.5
      ],
      [
        -636.0,
        -2827.099609375,
        810.5
      ],
      [
        -612.0,
        -2827.099853515625,
        810.5
      ],
      [
        -614.0,
        -2827.099609375,
        810.5
      ],
      [
        -612.0,
        -2827.099853515625,
        810.5
      ],
      [
        -610.0,
        -2827.099853515625,
        810.5
      ],
      [
        -733.0,
        -2827.099853515625,
        810.5
      ],
      [
        -731.0,
        -2827.099853515625,
        810.5
      ],
      [
        -640.5,
        -2827.099853515625,
        810.5
      ],
      [
        -638.0,
        -2827.099853515625,
        810.5
      ],
      [
        -670.5,
        -2827.099853515625,
        810.5
      ],
      [
        -668.0,
        -2827.099853515625,
        810.5
      ],
      [
        -700.5,
        -2827.099853515625,
        810.5
      ],
      [
        -698.0,
        -2827.099853515625,
        810.5
      ],
      [
        -668.0,
        -2827.099853515625,
        810.5
      ],
      [
        -640.5,
        -2827.099853515625,
        810.5
      ],
      [
        -698.0,
        -2827.099853515625,
        810.5
      ],
      [
        -670.5,
        -2827.099853515625,
        810.5
      ],
      [
        -731.0,
        -2827.099853515625,
        810.5
      ],
      [
        -700.5,
        -2827.099853515625,
        810.5
      ],
      [
        -687.0,
        -2812.0,
        810.5
      ],
      [
        -687.0,
        -2808.98095703125,
        766.0
      ],
      [
        -687.0,
        -2804.126953125,
        810.5
      ],
      [
        -684.0,
        -2812.0,
        810.5
      ],
      [
        -684.0,
        -2804.126953125,
        810.5
      ],
      [
        -684.0,
        -2808.98095703125,
        766.0
      ],
      [
        -658.0,
        -2808.0,
        784.0
      ],
      [
        -682.0,
        -2808.0,
        784.0
      ],
      [
        -614.0,
        -2826.0,
        805.0008544921875
      ],
      [
        -636.0,
        -2826.0,
        805.0008544921875
      ],
      [
        -614.0,
        -2826.0,
        805.0008544921875
      ],
      [
        -614.0,
        -2827.099609375,
        810.5
      ],
      [
        -636.0,
        -2827.099609375,
        810.5
      ],
      [
        -636.0,
        -2826.0,
        805.0008544921875
      ],
      [
        -682.0,
        -2808.0,
        784.0
      ],
      [
        -682.0,
        -2808.981201171875,
        766.0
      ],
      [
        -682.0,
        -2818.2001953125,
        766.0
      ],
      [
        -658.0,
        -2808.0,
        784.0
      ],
      [
        -658.0,
        -2818.2001953125,
        766.0
      ],
      [
        -658.0,
        -2808.981201171875,
        766.0
      ],
      [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      [
        -606.3539428710938,
        -2805.818359375,
        795.0
      ],
      [
        -639.1815795898438,
        -2805.818359375,
        795.0
      ],
      [
        -635.6460571289062,
        -2805.818359375,
        795.0
      ],
      [
        -606.3539428710938,
        -2805.818359375,
        795.0
      ],
      [
        -635.6460571289062,
        -2805.818359375,
        795.0
      ],
      [
        -640.8173828125,
        -2804.1826171875,
        810.0
      ],
      [
        -634.7095947265625,
        -2804.1826171875,
        810.0
      ],
      [
        -607.2904052734375,
        -2804.1826171875,
        810.0
      ],
      [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      [
        -607.2904052734375,
        -2804.1826171875,
        810.0
      ],
      [
        -634.7095947265625,
        -2804.1826171875,
        810.0
      ],
      [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      [
        -746.0,
        -2812.0,
        810.5
      ],
      [
        -746.0,
        -2804.126953125,
        810.5
      ],
      [
        -746.0,
        -2808.98095703125,
        766.0
      ],
      [
        -777.0,
        -2812.0,
        810.5
      ],
      [
        -777.0,
        -2804.126953125,
        810.5
      ],
      [
        -777.0,
        -2808.98095703125,
        766.0
      ],
      [
        -806.0,
        -2808.981201171875,
        766.0
      ],
      [
        -806.0,
        -2818.2001953125,
        766.0
      ],
      [
        -749.0,
        -2812.0,
        810.5
      ],
      [
        -749.0,
        -2808.98095703125,
        766.0
      ],
      [
        -749.0,
        -2804.126953125,
        810.5
      ],
      [
        -751.0,
        -2818.2001953125,
        766.0
      ],
      [
        -751.0,
        -2808.981201171875,
        766.0
      ],
      [
        -775.0,
        -2808.981201171875,
        766.0
      ],
      [
        -775.0,
        -2818.2001953125,
        766.0
      ],
      [
        -715.0,
        -2804.182861328125,
        810.0
      ],
      [
        -715.0,
        -2808.98095703125,
        766.0
      ],
      [
        -718.0,
        -2804.182861328125,
        810.0
      ],
      [
        -718.0,
        -2808.98095703125,
        766.0
      ],
      [
        -718.0,
        -2811.0,
        805.0
      ],
      [
        -715.0,
        -2811.0,
        805.0
      ],
      [
        -715.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -718.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -732.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -732.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -732.0,
        -2804.128173828125,
        810.5
      ],
      [
        -732.0,
        -2811.0,
        810.5
      ],
      [
        -720.0,
        -2818.2001953125,
        766.0
      ],
      [
        -720.0,
        -2808.981201171875,
        766.0
      ],
      [
        -744.0,
        -2808.981201171875,
        766.0
      ],
      [
        -744.0,
        -2818.2001953125,
        766.0
      ],
      [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -698.0,
        -2811.0,
        810.5
      ],
      [
        -698.0,
        -2804.128173828125,
        810.5
      ],
      [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -689.0,
        -2818.2001953125,
        766.0
      ],
      [
        -689.0,
        -2808.981201171875,
        766.0
      ],
      [
        -713.0,
        -2808.981201171875,
        766.0
      ],
      [
        -713.0,
        -2818.2001953125,
        766.0
      ],
      [
        -733.0,
        -2823.0,
        823.0
      ],
      [
        -733.0,
        -2823.0,
        821.5
      ],
      [
        -733.0,
        -2824.5,
        821.5
      ],
      [
        -733.0,
        -2824.5,
        823.0
      ],
      [
        -610.0,
        -2823.0,
        821.5
      ],
      [
        -610.0,
        -2823.0,
        823.0
      ],
      [
        -610.0,
        -2824.5,
        823.0
      ],
      [
        -610.0,
        -2824.5,
        821.5
      ],
      [
        -610.0,
        -2823.0,
        825.0
      ],
      [
        -610.0,
        -2824.5,
        825.0
      ],
      [
        -733.0,
        -2824.5,
        825.0
      ],
      [
        -733.0,
        -2823.0,
        825.0
      ],
      [
        -610.0,
        -2824.5,
        810.5
      ],
      [
        -610.0,
        -2823.0,
        810.5
      ],
      [
        -733.0,
        -2823.0,
        810.5
      ],
      [
        -733.0,
        -2824.5,
        810.5
      ],
      [
        -733.0,
        -2830.0,
        825.0
      ],
      [
        -733.0,
        -2827.099853515625,
        810.5
      ],
      [
        -610.0,
        -2827.099853515625,
        810.5
      ],
      [
        -610.0,
        -2830.0,
        825.0
      ],
      [
        -611.5,
        -2829.2998046875,
        821.5
      ],
      [
        -610.0,
        -2829.2998046875,
        821.5
      ],
      [
        -670.0,
        -2829.2998046875,
        821.5
      ],
      [
        -668.5,
        -2829.2998046875,
        821.5
      ],
      [
        -733.0,
        -2829.2998046875,
        821.5
      ],
      [
        -731.5,
        -2829.2998046875,
        821.5
      ],
      [
        -733.0,
        -2829.599853515625,
        823.0
      ],
      [
        -731.5,
        -2829.599853515625,
        823.0
      ],
      [
        -670.0,
        -2829.599853515625,
        823.0
      ],
      [
        -668.5,
        -2829.599853515625,
        823.0
      ],
      [
        -611.5,
        -2829.599853515625,
        823.0
      ],
      [
        -610.0,
        -2829.599853515625,
        823.0
      ],
      [
        -670.0,
        -2829.2998046875,
        821.5
      ],
      [
        -670.0,
        -2829.599853515625,
        823.0
      ],
      [
        -611.5,
        -2829.2998046875,
        821.5
      ],
      [
        -611.5,
        -2829.599853515625,
        823.0
      ],
      [
        -668.5,
        -2829.599853515625,
        823.0
      ],
      [
        -668.5,
        -2829.2998046875,
        821.5
      ],
      [
        -731.5,
        -2829.599853515625,
        823.0
      ],
      [
        -731.5,
        -2829.2998046875,
        821.5
      ],
      [
        -725.0,
        -2803.09228515625,
        820.0
      ],
      [
        -705.0,
        -2803.09228515625,
        820.0
      ],
      [
        -687.0,
        -2812.0,
        820.0
      ],
      [
        -687.0,
        -2803.0908203125,
        820.0
      ],
      [
        -684.0,
        -2812.0,
        820.0
      ],
      [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      [
        -732.0,
        -2803.092041015625,
        820.0
      ],
      [
        -732.0,
        -2811.0,
        820.0
      ],
      [
        -698.0,
        -2811.0,
        820.0
      ],
      [
        -698.0,
        -2803.092041015625,
        820.0
      ],
      [
        -702.5,
        -2804.128173828125,
        810.5
      ],
      [
        -705.0,
        -2803.09228515625,
        820.0
      ],
      [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      [
        -725.0,
        -2803.09228515625,
        820.0
      ],
      [
        -656.0,
        -2800.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        795.0
      ],
      [
        -656.0,
        -2690.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        812.0
      ],
      [
        -656.0,
        -2690.0,
        812.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -611.0,
        -2774.0,
        810.5
      ],
      [
        -617.0,
        -2768.0,
        810.5
      ],
      [
        -611.0,
        -2708.0,
        810.5
      ],
      [
        -617.0,
        -2702.0,
        810.5
      ],
      [
        -617.0,
        -2722.0,
        810.5
      ],
      [
        -611.0,
        -2716.0,
        810.5
      ],
      [
        -625.0,
        -2722.0,
        810.5
      ],
      [
        -617.0,
        -2722.0,
        810.5
      ],
      [
        -625.0,
        -2702.0,
        810.5
      ],
      [
        -617.0,
        -2702.0,
        810.5
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        810.0
      ],
      [
        -627.2115478515625,
        -2714.39892578125,
        810.5
      ],
      [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        810.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        810.0
      ],
      [
        -623.3990478515625,
        -2705.577880859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2709.390380859375,
        810.5
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        810.0
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        810.0
      ],
      [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      [
        -618.390380859375,
        -2718.21142578125,
        810.5
      ],
      [
        -618.3646850585938,
        -2718.293212890625,
        810.0
      ],
      [
        -618.3646850585938,
        -2705.505859375,
        810.0
      ],
      [
        -618.390380859375,
        -2705.577880859375,
        810.5
      ],
      [
        -623.3990478515625,
        -2705.577880859375,
        810.5
      ],
      [
        -623.434326171875,
        -2705.505859375,
        810.0
      ],
      [
        -617.0,
        -2788.0,
        810.5
      ],
      [
        -611.0,
        -2782.0,
        810.5
      ],
      [
        -625.0,
        -2788.0,
        810.5
      ],
      [
        -617.0,
        -2788.0,
        810.5
      ],
      [
        -625.0,
        -2768.0,
        810.5
      ],
      [
        -617.0,
        -2768.0,
        810.5
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      [
        -623.3990478515625,
        -2784.21142578125,
        810.5
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        810.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        810.0
      ],
      [
        -623.3990478515625,
        -2771.577880859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2775.390380859375,
        810.5
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        810.0
      ],
      [
        -623.3990478515625,
        -2784.21142578125,
        810.5
      ],
      [
        -618.390380859375,
        -2784.21142578125,
        810.5
      ],
      [
        -618.3646850585938,
        -2784.293212890625,
        810.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -627.2115478515625,
        -2775.390380859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -618.3646850585938,
        -2771.505859375,
        810.0
      ],
      [
        -618.390380859375,
        -2771.577880859375,
        810.5
      ],
      [
        -623.3990478515625,
        -2771.577880859375,
        810.5
      ],
      [
        -623.434326171875,
        -2771.505859375,
        810.0
      ],
      [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      [
        -623.005126953125,
        -2771.505859375,
        812.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        812.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        812.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        812.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        812.0
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        812.0
      ],
      [
        -618.3646850585938,
        -2718.293212890625,
        812.0
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        812.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        812.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        812.0
      ],
      [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        812.0
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        812.0
      ],
      [
        -623.1844482421875,
        -2705.577880859375,
        810.5
      ],
      [
        -623.165283203125,
        -2718.21142578125,
        810.5
      ],
      [
        -572.5,
        -2772.0,
        799.0
      ],
      [
        -572.5,
        -2767.5,
        799.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -631.0,
        -2779.171630859375,
        799.5499877929688
      ],
      [
        -615.0001831054688,
        -2786.000244140625,
        799.5499877929688
      ],
      [
        -631.0,
        -2779.171630859375,
        799.5499877929688
      ],
      [
        -633.0,
        -2778.23583984375,
        795.0
      ],
      [
        -622.171630859375,
        -2788.0,
        799.5499877929688
      ],
      [
        -645.0,
        -2770.0,
        798.5784912109375
      ],
      [
        -646.5,
        -2770.0,
        797.8497924804688
      ],
      [
        -656.0,
        -2800.0,
        798.5
      ],
      [
        -656.0,
        -2795.5,
        798.0
      ],
      [
        -656.0,
        -2795.5,
        798.0
      ],
      [
        -656.0,
        -2795.5,
        797.5
      ],
      [
        -651.0,
        -2791.0,
        797.5
      ],
      [
        -655.5003051757812,
        -2760.5,
        797.5
      ],
      [
        -656.0,
        -2760.5,
        798.0
      ],
      [
        -656.0,
        -2756.0,
        798.5
      ],
      [
        -656.0,
        -2760.5,
        797.5
      ],
      [
        -656.0,
        -2760.5,
        798.0
      ],
      [
        -656.0,
        -2690.0,
        812.0
      ],
      [
        -656.0,
        -2690.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        812.0
      ],
      [
        -633.0,
        -2701.85888671875,
        827.0
      ],
      [
        -632.6690063476562,
        -2702.058349609375,
        826.2470092773438
      ],
      [
        -645.0,
        -2704.0,
        823.4478759765625
      ],
      [
        -646.5,
        -2704.0,
        824.1962890625
      ],
      [
        -646.5,
        -2720.533203125,
        822.4500122070312
      ],
      [
        -645.0,
        -2720.533203125,
        822.4500122070312
      ],
      [
        -645.0,
        -2703.466796875,
        822.4500122070312
      ],
      [
        -646.5,
        -2703.466796875,
        822.4500122070312
      ],
      [
        -656.0,
        -2734.0,
        815.5
      ],
      [
        -656.0,
        -2729.5,
        815.0
      ],
      [
        -656.0,
        -2729.5,
        815.0
      ],
      [
        -656.0,
        -2729.5,
        814.5
      ],
      [
        -651.0,
        -2725.000244140625,
        814.5
      ],
      [
        -655.4998168945312,
        -2694.5,
        814.5
      ],
      [
        -656.0,
        -2694.5,
        815.0
      ],
      [
        -656.0,
        -2690.0,
        815.5
      ],
      [
        -656.0,
        -2694.5,
        814.5
      ],
      [
        -656.0,
        -2694.5,
        815.0
      ],
      [
        -701.5,
        -2690.0,
        827.5
      ],
      [
        -700.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -700.0,
        -2690.0,
        827.5
      ],
      [
        -701.5,
        -2690.0,
        830.0
      ],
      [
        -700.0,
        -2690.0,
        830.0
      ],
      [
        -700.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -700.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -701.5,
        -2800.0,
        827.5
      ],
      [
        -700.0,
        -2800.0,
        827.5
      ],
      [
        -700.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -700.0,
        -2800.0,
        830.0
      ],
      [
        -701.5,
        -2800.0,
        830.0
      ],
      [
        -700.7999877929688,
        -2690.0,
        810.0
      ],
      [
        -701.5,
        -2690.0,
        812.0
      ],
      [
        -700.0,
        -2690.0,
        812.0
      ],
      [
        -700.0,
        -2690.0,
        810.0
      ],
      [
        -701.5,
        -2800.0,
        812.0
      ],
      [
        -700.7999877929688,
        -2800.0,
        810.0
      ],
      [
        -700.0,
        -2800.0,
        810.0
      ],
      [
        -700.0,
        -2800.0,
        812.0
      ],
      [
        -674.6665649414062,
        -2688.0576171875,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.100341796875,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.701416015625,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.820556640625,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.0576171875,
        810.0
      ],
      [
        -674.6666870117188,
        -2736.0,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.820556640625,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.701416015625,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.100341796875,
        810.0
      ],
      [
        -674.6665649414062,
        -2754.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2802.0,
        810.0
      ],
      [
        -682.5999755859375,
        -2736.0,
        827.0
      ],
      [
        -656.0,
        -2736.0,
        827.0
      ],
      [
        -682.5999755859375,
        -2688.0,
        827.0
      ],
      [
        -656.0,
        -2688.0,
        827.0
      ],
      [
        -682.5999755859375,
        -2754.0,
        827.0
      ],
      [
        -656.0,
        -2754.0,
        827.0
      ],
      [
        -674.6666870117188,
        -2736.0,
        810.0
      ],
      [
        -675.6000366210938,
        -2736.0,
        812.0
      ],
      [
        -656.0,
        -2736.0,
        812.0
      ],
      [
        -656.0,
        -2736.0,
        810.0
      ],
      [
        -675.6000366210938,
        -2688.0,
        812.0
      ],
      [
        -674.6666870117188,
        -2688.0,
        810.0
      ],
      [
        -656.0,
        -2688.0,
        810.0
      ],
      [
        -656.0,
        -2688.0,
        812.0
      ],
      [
        -675.6000366210938,
        -2754.0,
        812.0
      ],
      [
        -674.6666870117188,
        -2754.0,
        810.0
      ],
      [
        -656.0,
        -2754.0,
        810.0
      ],
      [
        -656.0,
        -2754.0,
        812.0
      ],
      [
        -676.7667236328125,
        -2736.0,
        814.5
      ],
      [
        -656.0,
        -2736.0,
        814.5
      ],
      [
        -676.7667236328125,
        -2688.0,
        814.5
      ],
      [
        -656.0,
        -2688.0,
        814.5
      ],
      [
        -675.6666870117188,
        -2734.0,
        814.5
      ],
      [
        -656.0,
        -2734.0,
        814.5
      ],
      [
        -675.6666870117188,
        -2690.0,
        814.5
      ],
      [
        -656.0,
        -2690.0,
        814.5
      ],
      [
        -676.7667236328125,
        -2754.0,
        814.5
      ],
      [
        -656.0,
        -2754.0,
        814.5
      ],
      [
        -680.2666625976562,
        -2736.0,
        822.0
      ],
      [
        -656.0,
        -2736.0,
        822.0
      ],
      [
        -680.2666625976562,
        -2688.0,
        822.0
      ],
      [
        -656.0,
        -2688.0,
        822.0
      ],
      [
        -679.1666870117188,
        -2734.0,
        822.0
      ],
      [
        -656.0,
        -2734.0,
        822.0
      ],
      [
        -679.1666870117188,
        -2690.0,
        822.0
      ],
      [
        -656.0,
        -2690.0,
        822.0
      ],
      [
        -680.2666625976562,
        -2754.0,
        822.0
      ],
      [
        -656.0,
        -2754.0,
        822.0
      ],
      [
        -677.10888671875,
        -2731.599853515625,
        815.2333374023438
      ],
      [
        -676.0088500976562,
        -2731.599853515625,
        815.2333374023438
      ],
      [
        -677.1400146484375,
        -2691.800048828125,
        815.2999877929688
      ],
      [
        -676.0399780273438,
        -2691.800048828125,
        815.2999877929688
      ],
      [
        -698.0,
        -2690.0,
        810.0
      ],
      [
        -698.0,
        -2685.8173828125,
        810.0
      ],
      [
        -698.0,
        -2690.0,
        810.0
      ],
      [
        -698.0,
        -2800.0,
        810.0
      ],
      [
        -698.0,
        -2804.1826171875,
        810.0
      ],
      [
        -698.0,
        -2800.0,
        810.0
      ],
      [
        -684.0,
        -2688.0,
        810.0
      ],
      [
        -687.0,
        -2688.0,
        810.0
      ],
      [
        -687.0,
        -2688.0,
        810.0
      ],
      [
        -687.0,
        -2685.818359375,
        810.0
      ],
      [
        -684.0,
        -2688.0,
        810.0
      ],
      [
        -684.0,
        -2685.818359375,
        810.0
      ],
      [
        -687.0,
        -2802.0,
        810.0
      ],
      [
        -684.0,
        -2802.0,
        810.0
      ],
      [
        -687.0,
        -2802.0,
        810.0
      ],
      [
        -687.0,
        -2804.181640625,
        810.0
      ],
      [
        -684.0,
        -2802.0,
        810.0
      ],
      [
        -684.0,
        -2804.181640625,
        810.0
      ],
      [
        -728.5,
        -2690.0,
        827.5
      ],
      [
        -730.0,
        -2690.0,
        827.5
      ],
      [
        -730.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -730.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -730.0,
        -2690.0,
        830.0
      ],
      [
        -728.5,
        -2690.0,
        830.0
      ],
      [
        -728.5,
        -2800.0,
        827.5
      ],
      [
        -730.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -730.0,
        -2800.0,
        827.5
      ],
      [
        -728.5,
        -2800.0,
        830.0
      ],
      [
        -730.0,
        -2800.0,
        830.0
      ],
      [
        -730.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -728.5,
        -2690.0,
        812.0
      ],
      [
        -729.2000122070312,
        -2690.0,
        810.0
      ],
      [
        -730.0,
        -2690.0,
        810.0
      ],
      [
        -730.0,
        -2690.0,
        812.0
      ],
      [
        -729.2000122070312,
        -2800.0,
        810.0
      ],
      [
        -728.5,
        -2800.0,
        812.0
      ],
      [
        -730.0,
        -2800.0,
        812.0
      ],
      [
        -730.0,
        -2800.0,
        810.0
      ],
      [
        -808.0,
        -2696.3271484375,
        810.0
      ],
      [
        -808.0,
        -2685.818115234375,
        810.0
      ],
      [
        -808.0,
        -2804.181884765625,
        810.0
      ],
      [
        -808.0,
        -2793.6728515625,
        810.0
      ],
      [
        -808.0,
        -2699.30908203125,
        810.0
      ],
      [
        -808.0,
        -2696.3271484375,
        810.0
      ],
      [
        -808.0,
        -2793.6728515625,
        810.0
      ],
      [
        -808.0,
        -2790.69091796875,
        810.0
      ],
      [
        -808.0,
        -2790.69091796875,
        810.0
      ],
      [
        -808.0,
        -2699.30908203125,
        810.0
      ],
      [
        -732.0,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2685.8173828125,
        810.0
      ],
      [
        -732.0,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2800.0,
        810.0
      ],
      [
        -732.0,
        -2804.1826171875,
        810.0
      ],
      [
        -732.0,
        -2800.0,
        810.0
      ],
      [
        -746.0,
        -2688.0,
        810.0
      ],
      [
        -749.0,
        -2688.0,
        810.0
      ],
      [
        -777.0,
        -2688.0,
        810.0
      ],
      [
        -780.0,
        -2688.0,
        810.0
      ],
      [
        -749.0,
        -2688.0,
        810.0
      ],
      [
        -749.0,
        -2685.818359375,
        810.0
      ],
      [
        -746.0,
        -2688.0,
        810.0
      ],
      [
        -746.0,
        -2685.818359375,
        810.0
      ],
      [
        -777.0,
        -2688.0,
        810.0
      ],
      [
        -777.0,
        -2685.818359375,
        810.0
      ],
      [
        -749.0,
        -2802.0,
        810.0
      ],
      [
        -746.0,
        -2802.0,
        810.0
      ],
      [
        -780.0,
        -2802.0,
        810.0
      ],
      [
        -777.0,
        -2802.0,
        810.0
      ],
      [
        -749.0,
        -2802.0,
        810.0
      ],
      [
        -749.0,
        -2804.181640625,
        810.0
      ],
      [
        -746.0,
        -2802.0,
        810.0
      ],
      [
        -746.0,
        -2804.181640625,
        810.0
      ],
      [
        -777.0,
        -2802.0,
        810.0
      ],
      [
        -777.0,
        -2804.181640625,
        810.0
      ],
      [
        -825.7378540039062,
        -2708.475830078125,
        775.0
      ],
      [
        -825.7378540039062,
        -2708.475830078125,
        766.0
      ],
      [
        -819.5,
        -2794.0,
        766.0
      ],
      [
        -819.5,
        -2794.0,
        777.5
      ],
      [
        -825.738037109375,
        -2781.524169921875,
        775.0
      ],
      [
        -825.738037109375,
        -2781.524169921875,
        766.0
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2720.7001953125,
        766.0
      ],
      [
        -808.0,
        -2710.89990234375,
        775.0
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -808.0,
        -2707.89990234375,
        770.5
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -808.0,
        -2719.10009765625,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2719.10009765625,
        766.0
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -808.0,
        -2710.89990234375,
        766.0
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -808.0,
        -2779.10009765625,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2769.5,
        770.5
      ],
      [
        -808.0,
        -2770.89990234375,
        766.0
      ],
      [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2779.10009765625,
        766.0
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -667.6666870117188,
        -2736.0,
        795.0
      ],
      [
        -656.0,
        -2736.0,
        795.0
      ],
      [
        -667.6666870117188,
        -2688.0,
        795.0
      ],
      [
        -656.0,
        -2688.0,
        795.0
      ],
      [
        -658.0,
        -2682.28564453125,
        774.2857055664062
      ],
      [
        -656.0,
        -2684.0,
        770.0001220703125
      ],
      [
        -658.0,
        -2682.28564453125,
        774.2857055664062
      ],
      [
        -658.0,
        -2681.922119140625,
        774.2857055664062
      ],
      [
        -667.6666870117188,
        -2754.0,
        795.0
      ],
      [
        -656.0,
        -2754.0,
        795.0
      ],
      [
        -656.0,
        -2806.0,
        770.0001220703125
      ],
      [
        -658.0,
        -2807.71435546875,
        774.2857055664062
      ],
      [
        -658.0,
        -2807.71435546875,
        774.2857055664062
      ],
      [
        -658.0,
        -2808.077880859375,
        774.2857055664062
      ],
      [
        -668.8333740234375,
        -2736.0,
        797.5
      ],
      [
        -667.6668701171875,
        -2736.0,
        797.5
      ],
      [
        -666.500244140625,
        -2736.0,
        795.0
      ],
      [
        -668.8333740234375,
        -2688.0,
        797.5
      ],
      [
        -666.500244140625,
        -2688.0,
        795.0
      ],
      [
        -667.6668701171875,
        -2688.0,
        797.5
      ],
      [
        -668.8333740234375,
        -2754.0,
        797.5
      ],
      [
        -666.500244140625,
        -2754.0,
        795.0
      ],
      [
        -667.6668701171875,
        -2754.0,
        797.5
      ],
      [
        -672.3333740234375,
        -2736.0,
        805.0
      ],
      [
        -673.5,
        -2736.0,
        810.0
      ],
      [
        -671.166748046875,
        -2736.0,
        805.0
      ],
      [
        -672.3333740234375,
        -2688.0,
        805.0
      ],
      [
        -671.166748046875,
        -2688.0,
        805.0
      ],
      [
        -673.5,
        -2688.0,
        810.0
      ],
      [
        -672.3333740234375,
        -2754.0,
        805.0
      ],
      [
        -671.166748046875,
        -2754.0,
        805.0
      ],
      [
        -673.5,
        -2754.0,
        810.0
      ],
      [
        -777.0,
        -2682.0,
        775.0
      ],
      [
        -777.0,
        -2685.60009765625,
        766.0
      ],
      [
        -749.0,
        -2682.0,
        775.0
      ],
      [
        -746.0,
        -2682.0,
        775.0
      ],
      [
        -746.0,
        -2685.60009765625,
        766.0
      ],
      [
        -749.0,
        -2685.60009765625,
        766.0
      ],
      [
        -777.0,
        -2808.0,
        775.0
      ],
      [
        -777.0,
        -2804.39990234375,
        766.0
      ],
      [
        -746.0,
        -2808.0,
        775.0
      ],
      [
        -749.0,
        -2808.0,
        775.0
      ],
      [
        -749.0,
        -2804.39990234375,
        766.0
      ],
      [
        -746.0,
        -2804.39990234375,
        766.0
      ],
      [
        -684.0,
        -2808.0,
        775.0
      ],
      [
        -687.0,
        -2808.0,
        775.0
      ],
      [
        -687.0,
        -2804.39990234375,
        766.0
      ],
      [
        -684.0,
        -2804.39990234375,
        766.0
      ],
      [
        -687.0,
        -2682.0,
        775.0
      ],
      [
        -684.0,
        -2682.0,
        775.0
      ],
      [
        -684.0,
        -2685.60009765625,
        766.0
      ],
      [
        -687.0,
        -2685.60009765625,
        766.0
      ],
      [
        -718.0,
        -2682.0,
        775.0
      ],
      [
        -715.0,
        -2682.0,
        775.0
      ],
      [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      [
        -718.0,
        -2685.60009765625,
        766.0
      ],
      [
        -715.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -718.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -718.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -715.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2688.0,
        810.0
      ],
      [
        -732.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2688.0,
        810.0
      ],
      [
        -715.0,
        -2808.0,
        775.0
      ],
      [
        -718.0,
        -2808.0,
        775.0
      ],
      [
        -718.0,
        -2804.39990234375,
        766.0
      ],
      [
        -715.0,
        -2804.39990234375,
        766.0
      ],
      [
        -718.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -715.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -715.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -718.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2802.0,
        810.0
      ],
      [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2802.0,
        810.0
      ],
      [
        -698.0,
        -2688.166748046875,
        807.5
      ],
      [
        -732.0,
        -2688.166748046875,
        807.5
      ],
      [
        -732.5,
        -2690.0,
        808.0
      ],
      [
        -732.5,
        -2697.333251953125,
        810.0
      ],
      [
        -697.5,
        -2697.333251953125,
        810.0
      ],
      [
        -697.5,
        -2690.0,
        808.0
      ],
      [
        -732.0,
        -2688.166748046875,
        807.5
      ],
      [
        -732.0,
        -2688.0,
        807.5
      ],
      [
        -698.0,
        -2688.166748046875,
        807.5
      ],
      [
        -698.0,
        -2688.0,
        807.5
      ],
      [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      [
        -732.5,
        -2792.667236328125,
        810.0
      ],
      [
        -732.5,
        -2800.0,
        808.0000610351562
      ],
      [
        -697.5,
        -2800.0,
        808.0000610351562
      ],
      [
        -697.5,
        -2792.667236328125,
        810.0
      ],
      [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      [
        -732.0,
        -2802.0,
        807.5
      ],
      [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      [
        -698.0,
        -2802.0,
        807.5
      ],
      [
        -733.0,
        -2855.5,
        823.0
      ],
      [
        -733.0,
        -2855.5,
        821.5
      ],
      [
        -733.0,
        -2857.0,
        821.5
      ],
      [
        -733.0,
        -2857.0,
        823.0
      ],
      [
        -610.0,
        -2855.5,
        821.5
      ],
      [
        -610.0,
        -2855.5,
        823.0
      ],
      [
        -610.0,
        -2857.0,
        823.0
      ],
      [
        -610.0,
        -2857.0,
        821.5
      ],
      [
        -610.0,
        -2855.5,
        825.0
      ],
      [
        -610.0,
        -2857.0,
        825.0
      ],
      [
        -733.0,
        -2857.0,
        825.0
      ],
      [
        -733.0,
        -2855.5,
        825.0
      ],
      [
        -733.0,
        -2855.5,
        810.5
      ],
      [
        -733.0,
        -2857.0,
        810.5
      ],
      [
        -610.0,
        -2857.0,
        810.5
      ],
      [
        -610.0,
        -2855.5,
        810.5
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        -0.9805822372436523,
        -0.19610846042633057
      ],
      "plane_d": -2613.258056640625,
      "bbox_min": [
        -871.5,
        -2865.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -871.5,
        -2830.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2730.0,
      "bbox_min": [
        -871.5,
        -2812.0,
        718.0
      ],
      "bbox_max": [
        -610.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": -2540.26513671875,
      "bbox_min": [
        -871.5,
        -2730.0,
        718.0
      ],
      "bbox_max": [
        -610.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        718.0
      ],
      "bbox_max": [
        -610.0,
        -2633.0,
        766.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2715.0,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -610.0,
        -2633.0,
        766.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2633.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -810.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -812.0,
        -2698.3701171875,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2698.3701171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2698.3701171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657039642334,
        -0.0
      ],
      "plane_d": -2734.01806640625,
      "bbox_min": [
        -840.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": -472.70477294921875,
      "bbox_min": [
        -839.0,
        -2708.53271484375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.05712890625,
        765.0
      ],
      "bbox_max": [
        -838.545654296875,
        -2707.51171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -824.0,
        -2708.53271484375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2705.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2708.05712890625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -838.545654296875,
        -2708.11181640625,
        765.0
      ],
      "bbox_max": [
        -838.5,
        -2708.05712890625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2719.10009765625,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2710.89990234375,
      "bbox_min": [
        -825.0,
        -2710.89990234375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -812.0,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2701.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.3328201174736023,
        0.9429903626441956
      ],
      "plane_d": 165.30062866210938,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -713.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -682.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.778864265768789e-05,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.974853515625,
      "bbox_min": [
        -658.0,
        -2686.800048828125,
        763.0
      ],
      "bbox_max": [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 751.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284753799438477,
        0.37139391899108887
      ],
      "plane_d": -2778.001220703125,
      "bbox_min": [
        -808.0,
        -2686.800048828125,
        763.0
      ],
      "bbox_max": [
        -806.0,
        -2685.60009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2730.0,
        764.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -871.5,
        -2812.0,
        718.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2781.89990234375,
      "bbox_min": [
        -840.5,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -839.0,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -871.5,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -871.5,
        -2801.800048828125,
        760.0
      ],
      "bbox_max": [
        -810.0,
        -2765.0,
        766.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2782.5,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2782.5,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2781.89990234375,
      "bbox_min": [
        -840.5,
        -2782.5,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -839.0,
        -2782.5,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -871.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -840.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.4472135901451111,
        -0.0
      ],
      "plane_d": 1982.497802734375,
      "bbox_min": [
        -839.0,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2781.46728515625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -839.0,
        -2782.5,
        765.0
      ],
      "bbox_max": [
        -838.5355834960938,
        -2781.942626953125,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -824.0,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2781.46728515625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -821.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -819.5,
        -2790.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -840.5,
        -2781.942626953125,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2765.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -838.5355834960938,
        -2781.942626953125,
        765.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2770.89990234375,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2770.89990234375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2779.10009765625,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -808.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -718.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2319.334716796875,
      "bbox_min": [
        -658.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -718.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -808.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -749.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -749.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -808.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.55350774852559e-05,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.257568359375,
      "bbox_min": [
        -808.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2761.800048828125,
        764.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2761.800048828125,
        764.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -808.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9941065907478333,
        -0.10840681195259094
      ],
      "plane_d": -2582.17919921875,
      "bbox_min": [
        -871.5,
        -2830.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -816.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -816.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2630.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 1045.4647216796875,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2630.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2630.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2630.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -749.0,
        -2633.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2630.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -749.0,
        -2633.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2630.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2667.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -687.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2625.0,
        825.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -687.0,
        -2633.0,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2630.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2653.0,
      "bbox_min": [
        -687.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2647.0,
      "bbox_min": [
        -687.0,
        -2647.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -687.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -687.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": -1050.5426025390625,
      "bbox_min": [
        -687.0,
        -2675.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -687.0,
        -2675.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -746.0,
        -2687.998291015625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2625.0,
        836.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -718.0,
        -2685.871826171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2630.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -718.0,
        -2685.46435546875,
        766.0
      ],
      "bbox_max": [
        -715.0,
        -2630.0,
        806.7630004882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2685.871826171875,
        805.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -689.0,
      "bbox_min": [
        -713.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -713.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -732.0,
        -2685.871826171875,
        805.0
      ],
      "bbox_max": [
        -718.0,
        -2679.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2685.871826171875,
        805.0
      ],
      "bbox_max": [
        -732.0,
        -2679.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -744.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -744.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2687.998291015625,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2625.0,
        836.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -733.0,
        -2687.998291015625,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2625.0,
        836.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2647.0,
      "bbox_min": [
        -733.0,
        -2687.998291015625,
        825.0
      ],
      "bbox_max": [
        -687.0,
        -2631.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2641.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -713.0,
        -2631.0,
        836.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2631.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -713.0,
        -2631.0,
        836.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -826.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -713.0,
        -2631.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -723.0,
      "bbox_min": [
        -723.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -723.0,
        -2631.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        826.0
      ],
      "bbox_max": [
        -713.0,
        -2631.0,
        836.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -713.0,
      "bbox_min": [
        -713.0,
        -2641.0,
        826.0
      ],
      "bbox_max": [
        -713.0,
        -2631.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2653.0,
      "bbox_min": [
        -733.0,
        -2687.998291015625,
        825.0
      ],
      "bbox_max": [
        -687.0,
        -2647.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2687.998291015625,
        825.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2687.998291015625,
        825.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.7999877929688,
      "bbox_min": [
        -733.0,
        -2653.0,
        825.7999877929688
      ],
      "bbox_max": [
        -687.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": -1050.5426025390625,
      "bbox_min": [
        -733.0,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -733.0,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2625.0,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -733.0,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -732.0,
        -2687.453125,
        810.9035034179688
      ],
      "bbox_max": [
        -698.0,
        -2675.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -732.0,
        -2687.453125,
        820.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2687.453125,
        820.0
      ],
      "bbox_max": [
        -732.0,
        -2679.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -732.0,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -698.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -732.0,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -732.0,
        -2679.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -733.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -705.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2675.0,
        820.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        816.6669311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -733.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -733.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -732.0,
        -2679.0,
        816.6669311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -684.0,
        -2687.671142578125,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -684.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        810.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9964426755905151,
        0.023930735886096954,
        0.08080419898033142
      ],
      "plane_d": -573.6027221679688,
      "bbox_min": [
        -658.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -573.5,
        -2642.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2839656174182892,
        0.9588344693183899
      ],
      "plane_d": -23.062828063964844,
      "bbox_min": [
        -573.699951171875,
        -2655.50634765625,
        806.5000610351562
      ],
      "bbox_max": [
        -573.5,
        -2642.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -684.0,
        -2687.671142578125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -684.0,
        -2687.671142578125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        827.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2653.0,
      "bbox_min": [
        -684.0,
        -2687.671142578125,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2682.0,
      "bbox_min": [
        -642.6710815429688,
        -2687.671142578125,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -573.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -569.0,
        -2675.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -642.6710815429688,
        -2687.671142578125,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2682.0,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -605.0,
        -2687.671142578125,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -573.0,
        -2687.56201171875,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2682.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.7999877929688,
      "bbox_min": [
        -684.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2647.0,
      "bbox_min": [
        -684.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": -1050.5426025390625,
      "bbox_min": [
        -684.0,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -684.0,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2682.0,
      "bbox_min": [
        -641.0354614257812,
        -2687.453125,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -573.5,
        -2682.0,
        819.1668090820312
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -573.5,
        -2682.0,
        819.1668090820312
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -573.5,
      "bbox_min": [
        -573.5,
        -2676.0,
        819.1668090820312
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        820.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -641.0354614257812,
        -2687.453125,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -605.0,
        -2687.453125,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -571.7999877929688,
        -2687.452880859375,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2682.0,
      "bbox_min": [
        -684.0,
        -2684.600341796875,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -684.0,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -600.5,
      "bbox_min": [
        -610.0,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        820.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9967281222343445,
        0.08082734793424606
      ],
      "plane_d": 2593.760009765625,
      "bbox_min": [
        -600.5,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2641.550048828125,
        820.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.2000732421875,
      "bbox_min": [
        -600.5,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2668.2998046875,
        820.0001220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -573.5,
      "bbox_min": [
        -573.5,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -573.5,
        -2676.0,
        814.2000732421875
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        820.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -573.5,
      "bbox_min": [
        -573.5,
        -2676.0,
        814.2000732421875
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        820.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.2000732421875,
      "bbox_min": [
        -600.5,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2641.550048828125,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -637.6325073242188,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -573.699951171875,
        -2668.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -610.0,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4190581738948822,
        -0.9079594016075134
      ],
      "plane_d": 1858.5928955078125,
      "bbox_min": [
        -610.0,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4190581738948822,
        -0.9079594016075134
      ],
      "plane_d": -362.41546630859375,
      "bbox_min": [
        -610.0,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.35897907614707947,
        0.9333456158638
      ],
      "plane_d": 197.86924743652344,
      "bbox_min": [
        -610.0,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        817.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.35897907614707947,
        0.9333456158638
      ],
      "plane_d": -1704.7198486328125,
      "bbox_min": [
        -610.0,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        817.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2665.0,
      "bbox_min": [
        -610.0,
        -2665.0,
        813.0
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        817.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2635.0,
      "bbox_min": [
        -610.0,
        -2635.0,
        813.0
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        817.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -684.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2625.0,
        820.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2630.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -652.5,
        -2630.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -652.5,
      "bbox_min": [
        -652.5,
        -2630.0,
        810.5
      ],
      "bbox_max": [
        -652.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -815.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -670.0,
        -2670.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2639.0,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2639.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -639.6002807617188,
        -2684.600341796875,
        812.0
      ],
      "bbox_max": [
        -602.3997192382812,
        -2682.0,
        814.166748046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -605.0,
        -2684.600341796875,
        812.0
      ],
      "bbox_max": [
        -602.3997192382812,
        -2682.0,
        814.166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941065907478333,
        -0.10840681195259094
      ],
      "plane_d": 2875.466064453125,
      "bbox_min": [
        -871.5,
        -2830.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -806.0,
        -2830.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2802.0,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        825.0
      ],
      "bbox_max": [
        -749.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        825.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -732.0,
        -2812.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2812.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2811.0,
        825.0
      ],
      "bbox_max": [
        -698.0,
        -2802.001708984375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2811.0,
        825.0
      ],
      "bbox_max": [
        -698.0,
        -2802.001708984375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -806.0,
        -2830.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2802.54541015625,
        825.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -806.0,
        -2827.099609375,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2827.099609375,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2808.0,
      "bbox_min": [
        -682.0,
        -2827.099609375,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -682.0,
        -2827.099609375,
        766.0
      ],
      "bbox_max": [
        -614.0,
        -2808.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2826.0,
      "bbox_min": [
        -636.0,
        -2827.099609375,
        805.0008544921875
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -614.0,
      "bbox_min": [
        -636.0,
        -2827.099609375,
        805.0008544921875
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 636.0,
      "bbox_min": [
        -636.0,
        -2827.099609375,
        805.0008544921875
      ],
      "bbox_max": [
        -636.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2808.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2808.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -682.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -682.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -640.8173828125,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -605.0,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -806.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -806.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -806.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -775.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -775.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -775.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -744.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -744.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -715.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -718.0,
        -2811.0,
        805.0
      ],
      "bbox_max": [
        -715.0,
        -2804.53564453125,
        806.7630004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -744.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -732.0,
        -2811.0,
        805.0
      ],
      "bbox_max": [
        -718.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2811.0,
        805.0
      ],
      "bbox_max": [
        -732.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -744.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -744.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -715.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -715.0,
        -2811.0,
        805.0
      ],
      "bbox_max": [
        -698.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2811.0,
        805.0
      ],
      "bbox_max": [
        -698.0,
        -2804.128173828125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -689.0,
      "bbox_min": [
        -713.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -713.0,
        -2821.800048828125,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2823.0,
      "bbox_min": [
        -777.0,
        -2830.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2824.5,
      "bbox_min": [
        -733.0,
        -2830.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2824.5,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -668.5,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -668.5,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -731.5,
        -2824.5,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2823.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -668.5,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -611.499755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 146.37127685546875,
      "bbox_min": [
        -668.5,
        -2824.5,
        818.5
      ],
      "bbox_max": [
        -611.499755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.00011508899478940293,
        0.7071067690849304
      ],
      "plane_d": -147.10687255859375,
      "bbox_min": [
        -612.999755859375,
        -2824.5,
        820.0
      ],
      "bbox_max": [
        -611.499755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        0.0,
        -0.7070779800415039
      ],
      "plane_d": 1051.4635009765625,
      "bbox_min": [
        -668.5,
        -2824.5,
        818.5
      ],
      "bbox_max": [
        -665.500244140625,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071643471717834,
        0.0,
        0.7070492506027222
      ],
      "plane_d": -1052.519775390625,
      "bbox_min": [
        -668.5,
        -2824.5,
        820.0
      ],
      "bbox_max": [
        -667.000244140625,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -669.999755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2824.5,
        810.5
      ],
      "bbox_max": [
        -733.0,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 105.00553131103516,
      "bbox_min": [
        -731.5,
        -2824.5,
        818.5
      ],
      "bbox_max": [
        -669.999755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.00011508899478940293,
        0.7071067690849304
      ],
      "plane_d": -105.74111938476562,
      "bbox_min": [
        -671.499755859375,
        -2824.5,
        820.0
      ],
      "bbox_max": [
        -669.999755859375,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        0.0,
        -0.7070779800415039
      ],
      "plane_d": 1096.012939453125,
      "bbox_min": [
        -731.5,
        -2824.5,
        818.5
      ],
      "bbox_max": [
        -728.500244140625,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071643471717834,
        0.0,
        0.7070492506027222
      ],
      "plane_d": -1097.071044921875,
      "bbox_min": [
        -731.5,
        -2824.5,
        820.0
      ],
      "bbox_max": [
        -730.000244140625,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2830.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -733.0,
        -2830.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2829.599853515625,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        823.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2829.599853515625,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        823.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -731.5,
        -2829.599853515625,
        821.5
      ],
      "bbox_max": [
        -611.5,
        -2824.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -668.5,
        -2829.599853515625,
        821.5
      ],
      "bbox_max": [
        -611.5,
        -2824.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2829.599853515625,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2824.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -731.5,
        -2829.599853515625,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2824.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1418.4561767578125,
      "bbox_min": [
        -733.0,
        -2827.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        821.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.00016276042151730508,
        0.0
      ],
      "plane_d": -669.5400390625,
      "bbox_min": [
        -733.0,
        -2827.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.00016276042151730508,
        0.0
      ],
      "plane_d": -611.0400390625,
      "bbox_min": [
        -670.0,
        -2827.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1417.3955078125,
      "bbox_min": [
        -611.5,
        -2826.0,
        820.0
      ],
      "bbox_max": [
        -610.0,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -670.0,
        -2827.5,
        818.5
      ],
      "bbox_max": [
        -668.5,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1417.3955078125,
      "bbox_min": [
        -670.0,
        -2826.0,
        820.0
      ],
      "bbox_max": [
        -668.5,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2827.5,
        818.5
      ],
      "bbox_max": [
        -731.5,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1417.3955078125,
      "bbox_min": [
        -733.0,
        -2826.0,
        820.0
      ],
      "bbox_max": [
        -731.5,
        -2824.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        -777.0,
        -2823.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2815.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -749.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -777.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -732.0,
        -2815.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -732.0,
        -2812.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2812.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2802.54541015625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2811.0,
        820.0
      ],
      "bbox_max": [
        -698.0,
        -2802.546875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2811.0,
        820.0
      ],
      "bbox_max": [
        -698.0,
        -2802.546875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -732.0,
        -2815.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2811.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2803.092041015625,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -732.0,
        -2815.0,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2803.092041015625,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2811.0,
        810.5
      ],
      "bbox_max": [
        -732.0,
        -2803.092041015625,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": -1172.1776123046875,
      "bbox_min": [
        -733.0,
        -2823.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2815.0,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2821.0,
      "bbox_min": [
        -733.0,
        -2823.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2815.0,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -670.5,
      "bbox_min": [
        -731.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -640.5,
      "bbox_min": [
        -668.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        -638.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -638.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -638.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        -668.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -668.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -731.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -731.0,
        -2821.0,
        810.5
      ],
      "bbox_max": [
        -731.0,
        -2815.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2823.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -733.0,
        -2823.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -670.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -611.5,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -611.5,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2821.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -670.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -670.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2823.0,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2823.0,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2821.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        827.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        827.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        827.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        827.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        812.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        812.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2393.556396484375,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2346.887451171875,
      "bbox_min": [
        -627.293212890625,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1488.459716796875,
      "bbox_min": [
        -627.293212890625,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2722.0,
      "bbox_min": [
        -627.293212890625,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2702.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -623.434326171875,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.434326171875,
        -2705.577880859375,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1535.1287841796875,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2788.0,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2768.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -623.434326171875,
        -2771.577880859375,
        810.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1488.459716796875,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2393.556396484375,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1535.1287841796875,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2788.0,
      "bbox_min": [
        -627.293212890625,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -617.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2768.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -617.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -627.293212890625,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -627.293212890625,
        -2780.39892578125,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      "bbox_max": [
        -627.1298828125,
        -2775.390380859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -623.36376953125,
        -2771.64990234375,
        811.0
      ],
      "bbox_max": [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1623.5675048828125,
      "bbox_min": [
        -627.293212890625,
        -2775.416015625,
        811.0
      ],
      "bbox_max": [
        -623.005126953125,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -623.434326171875,
        -2771.64990234375,
        811.0
      ],
      "bbox_max": [
        -623.005126953125,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2244.845458984375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        811.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2780.36376953125,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2346.887451171875,
      "bbox_min": [
        -627.293212890625,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2722.0,
      "bbox_min": [
        -627.293212890625,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -617.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2702.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -617.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2198.8017578125,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2551.857177734375,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1577.4268798828125,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2793.657470703125,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        811.0
      ],
      "bbox_max": [
        -627.1298828125,
        -2709.36474609375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.36376953125,
        -2705.64990234375,
        810.5
      ],
      "bbox_max": [
        -618.390380859375,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -627.2115478515625,
        -2709.416015625,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.3990478515625,
        -2705.64990234375,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -623.36376953125,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.390380859375,
        -2718.1298828125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -627.2115478515625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2714.36376953125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2718.1298828125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2690.0,
        810.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -572.5,
      "bbox_min": [
        -597.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -798.25,
      "bbox_min": [
        -572.5,
        -2772.0,
        798.25
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.0,
      "bbox_min": [
        -572.5,
        -2772.0,
        799.0
      ],
      "bbox_max": [
        -567.0,
        -2767.5,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.0,
      "bbox_min": [
        -597.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -572.5,
        -2760.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        -597.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -572.5,
        -2760.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -578.0,
      "bbox_min": [
        -597.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -572.5,
        -2767.5,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.0,
      "bbox_min": [
        -578.0,
        -2772.0,
        799.0
      ],
      "bbox_max": [
        -572.5,
        -2767.5,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2770.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -624.171630859375,
        -2705.505859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2370.928955078125,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -611.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -611.0,
        -2756.0,
        810.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -646.5,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -611.0,
        -2765.015625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -633.984375,
        -2788.0,
        795.0
      ],
      "bbox_max": [
        -611.0,
        -2765.015625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.5499877929688,
      "bbox_min": [
        -633.984375,
        -2786.000244140625,
        795.0
      ],
      "bbox_max": [
        -611.0,
        -2765.015625,
        810.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.20672766864299774,
        0.9089968204498291,
        0.36192330718040466
      ],
      "plane_d": 2099.176513671875,
      "bbox_min": [
        -633.984375,
        -2768.99853515625,
        795.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1061.7841796875,
      "bbox_min": [
        -633.984375,
        -2768.99853515625,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2765.015625,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": -899.3978881835938,
      "bbox_min": [
        -633.0,
        -2779.171630859375,
        795.0
      ],
      "bbox_max": [
        -631.0,
        -2773.171630859375,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -629.0,
        -2781.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -629.0,
        -2781.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -624.171630859375,
        -2771.505859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.5499877929688,
      "bbox_min": [
        -624.171630859375,
        -2788.0,
        799.5499877929688
      ],
      "bbox_max": [
        -615.0001831054688,
        -2786.0,
        799.5499877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9090052843093872,
        0.2066630721092224,
        0.36193883419036865
      ],
      "plane_d": -288.0338439941406,
      "bbox_min": [
        -646.5,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2770.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -2534.468505859375,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2787.00146484375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": -899.3978881835938,
      "bbox_min": [
        -646.5,
        -2782.828369140625,
        795.0
      ],
      "bbox_max": [
        -631.0,
        -2770.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        798.5784912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1875.025390625,
      "bbox_min": [
        -646.5,
        -2788.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2765.3193359375,
      "bbox_min": [
        -646.5,
        -2788.5,
        797.8497924804688
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2747.84619140625,
      "bbox_min": [
        -646.5,
        -2770.0,
        797.8497924804688
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        797.8497924804688
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1857.5523681640625,
      "bbox_min": [
        -646.5,
        -2770.0,
        802.5
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -484.4078674316406,
      "bbox_min": [
        -656.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -656.0,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2791.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2791.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -865.0101318359375,
      "bbox_min": [
        -656.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.5003051757812,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2760.5,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2767.5,
      "bbox_min": [
        -651.0,
        -2767.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2767.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -655.5003051757812,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -656.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2686.035400390625,
        827.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -597.0,
        -2760.0,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2687.016845703125,
        826.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -597.0,
        -2760.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        -597.0,
        -2760.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.0,
      "bbox_min": [
        -597.0,
        -2694.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2742.0,
      "bbox_min": [
        -656.0,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2686.035400390625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2244.845458984375,
      "bbox_min": [
        -629.0,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1623.5675048828125,
      "bbox_min": [
        -629.0,
        -2775.36474609375,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -624.171630859375,
        -2771.505859375,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1511.087158203125,
      "bbox_min": [
        -656.0,
        -2742.0,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2686.035400390625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2686.035400390625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -600.9645385742188,
        -2690.0,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2686.035400390625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -611.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -611.0,
        -2690.0,
        827.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 822.4500122070312,
      "bbox_min": [
        -646.5,
        -2724.984375,
        812.0
      ],
      "bbox_max": [
        -611.0,
        -2699.015625,
        827.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -692.4019775390625,
      "bbox_min": [
        -646.5,
        -2724.984375,
        822.4500122070312
      ],
      "bbox_max": [
        -625.0,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1518.7132568359375,
      "bbox_min": [
        -646.5,
        -2724.984375,
        822.4500122070312
      ],
      "bbox_max": [
        -625.0,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        -0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": -1754.7391357421875,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        822.4500122070312
      ],
      "bbox_max": [
        -630.00146484375,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        -0.0,
        -0.4024023413658142
      ],
      "plane_d": -246.7012939453125,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        822.4500122070312
      ],
      "bbox_max": [
        -630.00146484375,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 1678.1812744140625,
      "bbox_min": [
        -633.0,
        -2702.058349609375,
        826.2470092773438
      ],
      "bbox_max": [
        -630.00146484375,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 264.1494445800781,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2701.85888671875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        -0.20296648144721985,
        -0.40289273858070374
      ],
      "plane_d": -781.198974609375,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2701.85888671875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 1678.1812744140625,
      "bbox_min": [
        -633.984375,
        -2702.99853515625,
        826.2470092773438
      ],
      "bbox_max": [
        -632.6690063476562,
        -2701.85888671875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": -812.4891357421875,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2702.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        0.20296645164489746,
        -0.40289273858070374
      ],
      "plane_d": 319.6911315917969,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        826.2470092773438
      ],
      "bbox_max": [
        -633.0,
        -2716.828369140625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        823.4478759765625
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.533203125,
        822.4500122070312
      ],
      "bbox_max": [
        -645.0,
        -2703.466796875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2719.833740234375,
      "bbox_min": [
        -646.5,
        -2720.533203125,
        822.4500122070312
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        823.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1793.2071533203125,
      "bbox_min": [
        -646.5,
        -2704.0,
        822.4500122070312
      ],
      "bbox_max": [
        -645.0,
        -2703.466796875,
        824.1962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        824.1962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2198.8017578125,
      "bbox_min": [
        -629.0,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1577.4268798828125,
      "bbox_min": [
        -629.0,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2551.857177734375,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2793.657470703125,
      "bbox_min": [
        -624.171630859375,
        -2705.505859375,
        812.0
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1810.68017578125,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2702.36083984375,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2713.10009765625,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.60009765625,
      "bbox_min": [
        -646.5,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": -1025.1182861328125,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.7572631835938,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -634.0,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -634.0,
        -2710.60009765625,
        814.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": -124.59374237060547,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        814.5
      ],
      "bbox_max": [
        -634.0,
        -2710.60009765625,
        814.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1793.2071533203125,
      "bbox_min": [
        -646.5,
        -2703.466796875,
        819.5
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2719.833740234375,
      "bbox_min": [
        -646.5,
        -2722.5,
        819.5
      ],
      "bbox_max": [
        -645.0,
        -2720.533203125,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -508.5923767089844,
      "bbox_min": [
        -656.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -656.0,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2725.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2725.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -881.9061889648438,
      "bbox_min": [
        -656.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.4998168945312,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2694.5,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2701.5,
      "bbox_min": [
        -651.0,
        -2701.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2701.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -655.4998168945312,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -656.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -701.5,
      "bbox_min": [
        -808.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -701.5,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.5,
      "bbox_min": [
        -701.5,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        827.5
      ],
      "bbox_max": [
        -700.0,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -700.0,
        -2800.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2800.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -701.5,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -701.5,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9061815142631531,
        -0.0,
        -0.42288893461227417
      ],
      "plane_d": -268.8303527832031,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -684.0,
        -2754.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -684.0,
        -2754.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -684.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -684.0,
        -2754.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -682.5999755859375,
        -2754.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -675.6000366210938,
        -2754.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -675.6000366210938,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -675.6000366210938,
        -2754.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.5,
      "bbox_min": [
        -682.5999755859375,
        -2754.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -676.7667236328125,
        -2754.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -676.7667236328125,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -675.6666870117188,
        -2690.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -682.5999755859375,
        -2754.0,
        822.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -682.5999755859375,
        -2734.0,
        822.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -681.5,
        -2690.0,
        822.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -680.2666625976562,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -680.2666015625,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -680.2666015625,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -680.2666015625,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -508.5923767089844,
      "bbox_min": [
        -680.2666015625,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2729.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -677.10888671875,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2729.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 836.9039306640625,
      "bbox_min": [
        -677.10888671875,
        -2731.599853515625,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2730.5,
        815.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2732.0,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        815.2333374023438
      ],
      "bbox_max": [
        -676.0088500976562,
        -2730.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2198.55419921875,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        815.2333374023438
      ],
      "bbox_max": [
        -676.0088500976562,
        -2730.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 836.9039306640625,
      "bbox_min": [
        -677.2333984375,
        -2732.0,
        815.2333374023438
      ],
      "bbox_max": [
        -676.0088500976562,
        -2731.599853515625,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -680.2666015625,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1107.572998046875,
      "bbox_min": [
        -680.2666015625,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -677.1400146484375,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2171.512451171875,
      "bbox_min": [
        -677.1400146484375,
        -2693.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.800048828125,
        815.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2691.5,
      "bbox_min": [
        -680.2666015625,
        -2693.0,
        815.2999877929688
      ],
      "bbox_max": [
        -676.0399780273438,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -809.8623046875,
      "bbox_min": [
        -680.2666015625,
        -2693.0,
        815.2999877929688
      ],
      "bbox_max": [
        -676.0399780273438,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2171.512451171875,
      "bbox_min": [
        -677.2333984375,
        -2691.800048828125,
        815.2999877929688
      ],
      "bbox_max": [
        -676.0399780273438,
        -2691.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -680.2666625976562,
        -2754.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -700.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -700.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -700.0,
        -2720.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -700.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -700.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2690.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1368.2515869140625,
      "bbox_min": [
        -700.0,
        -2765.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -700.0,
        -2790.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2770.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -700.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 728.5,
      "bbox_min": [
        -808.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        -808.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.5,
      "bbox_min": [
        -730.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        827.5
      ],
      "bbox_max": [
        -728.5,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2800.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2800.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -730.0,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -730.0,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -780.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -732.5,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -732.5,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.5,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.5,
        -2720.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2690.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1368.2515869140625,
      "bbox_min": [
        -732.5,
        -2765.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -732.5,
        -2790.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2770.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -746.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -777.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -777.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -746.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 829.5,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -728.5,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -728.5,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2800.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -728.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -727.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        766.0
      ],
      "bbox_max": [
        -860.38818359375,
        -2698.3701171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        766.0
      ],
      "bbox_max": [
        -860.38818359375,
        -2698.3701171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        766.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2708.11181640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        766.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2708.11181640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        766.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2715.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.475830078125,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        766.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657039642334,
        -0.0
      ],
      "plane_d": -2734.01806640625,
      "bbox_min": [
        -836.8701171875,
        -2708.475830078125,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2708.11181640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -839.0,
        -2801.800048828125,
        766.0
      ],
      "bbox_max": [
        -819.5,
        -2781.89990234375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        766.0
      ],
      "bbox_max": [
        -819.5,
        -2794.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        766.0
      ],
      "bbox_max": [
        -825.738037109375,
        -2781.524169921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -825.738037109375,
        -2794.0,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -825.738037109375,
        -2781.524169921875,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2708.475830078125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2719.10009765625,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2710.89990234375,
      "bbox_min": [
        -825.0,
        -2710.89990234375,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2779.10009765625,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2779.099853515625,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -821.5,
        -2794.0,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2794.0,
        766.0
      ],
      "bbox_max": [
        -819.5,
        -2790.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -810.5,
        -2709.2998046875,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2709.2998046875,
      "bbox_min": [
        -810.5,
        -2709.2998046875,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2709.5,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -810.5,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2368.82861328125,
      "bbox_min": [
        -810.5,
        -2720.5,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2709.5,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2816.07568359375,
      "bbox_min": [
        -810.5,
        -2710.89990234375,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2709.5,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2883.870849609375,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -810.5,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2873.367431640625,
      "bbox_min": [
        -810.5,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2426.120361328125,
      "bbox_min": [
        -810.5,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2779.10009765625,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9061828851699829,
        0.0,
        -0.4228859543800354
      ],
      "plane_d": -268.8337707519531,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -674.6666870117188,
        -2808.077880859375,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -667.6666870117188,
        -2808.077880859375,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -667.6666870117188,
        -2688.0,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.778864265768789e-05,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.974853515625,
      "bbox_min": [
        -658.0,
        -2684.0,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2682.28564453125,
        774.2857055664062
      ],
      "bbox_max": [
        -658.0,
        -2681.922119140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -667.6666870117188,
        -2808.077880859375,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2319.334716796875,
      "bbox_min": [
        -658.0,
        -2808.077880859375,
        770.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2806.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.077880859375,
        774.2857055664062
      ],
      "bbox_max": [
        -658.0,
        -2807.71435546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9061887860298157,
        0.0,
        0.4228733777999878
      ],
      "plane_d": 267.79071044921875,
      "bbox_min": [
        -674.6666870117188,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.5,
      "bbox_min": [
        -674.6666870117188,
        -2798.0,
        795.0
      ],
      "bbox_max": [
        -666.500244140625,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -668.8333740234375,
        -2754.0,
        795.0
      ],
      "bbox_max": [
        -666.500244140625,
        -2688.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -668.8333740234375,
        -2688.0,
        795.0
      ],
      "bbox_max": [
        -666.500244140625,
        -2688.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -668.8333740234375,
        -2754.0,
        795.0
      ],
      "bbox_max": [
        -666.500244140625,
        -2754.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -674.6666870117188,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -674.6666870117188,
        -2754.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -674.6666870117188,
        -2688.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -674.6666870117188,
        -2754.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -672.3333740234375,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2688.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2758.0,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2221.01953125,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -860.8947143554688,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 887.6589965820312,
      "bbox_min": [
        -669.300048828125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2194.25537109375,
      "bbox_min": [
        -669.300048828125,
        -2759.5,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -672.3333740234375,
        -2736.0,
        797.5
      ],
      "bbox_max": [
        -667.6668701171875,
        -2688.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -672.3333740234375,
        -2688.0,
        797.5
      ],
      "bbox_max": [
        -667.6668701171875,
        -2688.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -673.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -673.5,
        -2754.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -673.5,
        -2688.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -673.5,
        -2754.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -673.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -484.4078674316406,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2795.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2795.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1097.9654541015625,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -749.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -777.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -777.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -751.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2707.89990234375,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -749.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -777.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -777.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -751.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -776.0,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -808.0,
        -2709.2998046875,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2709.2998046875,
      "bbox_min": [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2368.82861328125,
      "bbox_min": [
        -808.0,
        -2720.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2816.07568359375,
      "bbox_min": [
        -808.0,
        -2710.89990234375,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2883.870849609375,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2780.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -808.0,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2873.367431640625,
      "bbox_min": [
        -808.0,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2426.120361328125,
      "bbox_min": [
        -808.0,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2779.10009765625,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -687.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -684.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -684.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -682.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2804.39990234375,
        774.2857055664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -687.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -746.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -718.0,
        -2688.0,
        806.7630004882812
      ],
      "bbox_max": [
        -715.0,
        -2685.46435546875,
        807.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -715.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2688.0,
        806.7630004882812
      ],
      "bbox_max": [
        -698.0,
        -2685.46435546875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -689.0,
      "bbox_min": [
        -689.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -689.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -746.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2688.0,
        806.7630004882812
      ],
      "bbox_max": [
        -732.0,
        -2685.46435546875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -746.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -746.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -720.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -720.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -718.0,
        -2804.53564453125,
        806.7630004882812
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        807.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -715.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      "bbox_max": [
        -698.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -689.0,
      "bbox_min": [
        -715.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -689.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -715.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -715.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2804.53564453125,
        806.7630004882812
      ],
      "bbox_max": [
        -732.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -746.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -720.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -720.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -732.5,
        -2750.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -732.5,
        -2697.333251953125,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -732.0,
        -2697.333251953125,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -732.0,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2740.0,
      "bbox_min": [
        -732.5,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -732.5,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2792.667236328125,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2792.667236328125,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -732.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -816.0,
        -2865.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        825.7999877929688
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        810.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -614.0,
      "bbox_min": [
        -636.0,
        -2854.0,
        790.0
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 636.0,
      "bbox_min": [
        -636.0,
        -2854.0,
        790.0
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2854.0,
      "bbox_min": [
        -636.0,
        -2854.0,
        790.0
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2826.0,
      "bbox_min": [
        -636.0,
        -2826.0,
        790.0
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        805.0008544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 1045.4647216796875,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -607.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2920.363525390625,
      "bbox_min": [
        -816.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2818.2001953125,
        775.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2818.2001953125,
        775.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2818.2001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2818.2001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3328201174736023,
        0.9429903626441956
      ],
      "plane_d": -1661.8818359375,
      "bbox_min": [
        -806.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -658.0,
        -2823.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -713.0,
      "bbox_min": [
        -782.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -658.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -682.0,
      "bbox_min": [
        -689.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -658.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -658.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -658.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 689.0,
      "bbox_min": [
        -689.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -689.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 751.0,
      "bbox_min": [
        -782.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -720.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -782.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -782.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -720.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -720.0,
        -2823.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2827.099853515625,
        825.7999877929688
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -733.0,
        -2843.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2837.0,
        825.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2837.0,
      "bbox_min": [
        -733.0,
        -2843.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2837.0,
        825.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2843.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2837.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2843.0,
        825.0
      ],
      "bbox_max": [
        -610.0,
        -2837.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2857.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2827.099853515625,
        825.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2855.5,
      "bbox_min": [
        -733.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2827.099853515625,
        825.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2857.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2857.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2857.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -668.5,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -668.5,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -731.5,
        -2857.0,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -733.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -669.999755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -733.0,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -731.500244140625,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -669.999755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 105.00553131103516,
      "bbox_min": [
        -731.500244140625,
        -2857.0,
        818.5
      ],
      "bbox_max": [
        -669.999755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.00011508899478940293,
        0.7071067690849304
      ],
      "plane_d": -105.73738098144531,
      "bbox_min": [
        -671.499755859375,
        -2857.0,
        820.0
      ],
      "bbox_max": [
        -669.999755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        -0.00011509368050610647,
        -0.7070779800415039
      ],
      "plane_d": 1095.684326171875,
      "bbox_min": [
        -731.500244140625,
        -2857.0,
        818.5
      ],
      "bbox_max": [
        -728.500244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -668.500244140625,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 146.37127685546875,
      "bbox_min": [
        -668.500244140625,
        -2857.0,
        818.5
      ],
      "bbox_max": [
        -611.499755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.00011508899478940293,
        0.7071067690849304
      ],
      "plane_d": -147.10311889648438,
      "bbox_min": [
        -612.999755859375,
        -2857.0,
        820.0
      ],
      "bbox_max": [
        -611.499755859375,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        -0.00011509368050610647,
        -0.7070779800415039
      ],
      "plane_d": 1051.134765625,
      "bbox_min": [
        -668.500244140625,
        -2857.0,
        818.5
      ],
      "bbox_max": [
        -665.500244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071643471717834,
        0.0,
        0.7070492506027222
      ],
      "plane_d": -1052.519775390625,
      "bbox_min": [
        -668.500244140625,
        -2857.0,
        820.0
      ],
      "bbox_max": [
        -667.000244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2827.099853515625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2827.099853515625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2829.2998046875,
        823.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2829.2998046875,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -670.0,
        -2855.5,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2829.2998046875,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -611.5,
        -2855.5,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2829.599853515625,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -670.0,
        -2855.5,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2829.2998046875,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -670.0,
        -2855.5,
        823.0
      ],
      "bbox_max": [
        -668.5,
        -2829.599853515625,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2855.5,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2829.2998046875,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2829.599853515625,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2597.91015625,
      "bbox_min": [
        -733.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2852.5,
        821.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2852.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -670.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -610.0,
        -2852.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2598.970947265625,
      "bbox_min": [
        -611.5,
        -2855.5,
        820.0
      ],
      "bbox_max": [
        -610.0,
        -2854.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -670.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -668.5,
        -2852.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2598.970947265625,
      "bbox_min": [
        -670.0,
        -2855.5,
        820.0
      ],
      "bbox_max": [
        -668.5,
        -2854.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -731.5,
        -2852.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2598.970947265625,
      "bbox_min": [
        -733.0,
        -2855.5,
        820.0
      ],
      "bbox_max": [
        -731.5,
        -2854.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2865.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2464.06982421875,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.5,
      "bbox_min": [
        -731.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -640.5,
      "bbox_min": [
        -668.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        -638.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -612.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -638.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -638.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        -668.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -668.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -731.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -731.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -731.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        810.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.5,
      "bbox_min": [
        -670.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -611.5,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -611.5,
        -2859.0,
        823.0
      ],
      "bbox_max": [
        -610.0,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -670.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -670.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 668.5,
      "bbox_min": [
        -668.5,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -668.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -731.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        823.0
      ],
      "bbox_max": [
        -731.5,
        -2857.0,
        823.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt04b",
      "entity_class": "CGameArea",
      "piece_name": "mt04b",
      "offset": 54,
      "centroid": [
        -714.9583333333334,
        -2745.0416666666665,
        802.75
      ],
      "bbox_min": [
        -833.5,
        -2862.0,
        760.0
      ],
      "bbox_max": [
        -550.0,
        -2625.0,
        826.0
      ],
      "dimensions_source": {
        "span_x": 283.5,
        "span_y": 237.0,
        "height_z": 66.0,
        "door_width": 283.5,
        "door_depth": 237.0,
        "leaf_depth": 237.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          -0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -685.5,
          -2745.0,
          804.0
        ],
        [
          -685.5,
          -2675.0,
          804.0
        ],
        [
          -550.0,
          -2675.0,
          804.0
        ],
        [
          -550.0,
          -2745.0,
          804.0
        ],
        [
          -550.0,
          -2815.0,
          804.0
        ],
        [
          -685.5,
          -2815.0,
          804.0
        ],
        [
          -685.5,
          -2745.0,
          804.0
        ],
        [
          -550.0,
          -2745.0,
          804.0
        ],
        [
          -716.5,
          -2745.0,
          804.0
        ],
        [
          -685.5,
          -2745.0,
          804.0
        ],
        [
          -685.5,
          -2815.0,
          804.0
        ],
        [
          -716.5,
          -2815.0,
          804.0
        ],
        [
          -716.5,
          -2675.0,
          804.0
        ],
        [
          -685.5,
          -2675.0,
          804.0
        ],
        [
          -685.5,
          -2745.0,
          804.0
        ],
        [
          -716.5,
          -2745.0,
          804.0
        ],
        [
          -716.5,
          -2745.0,
          804.0
        ],
        [
          -747.5,
          -2745.0,
          804.0
        ],
        [
          -747.5,
          -2675.0,
          804.0
        ],
        [
          -716.5,
          -2675.0,
          804.0
        ],
        [
          -716.5,
          -2815.0,
          804.0
        ],
        [
          -747.5,
          -2815.0,
          804.0
        ],
        [
          -747.5,
          -2745.0,
          804.0
        ],
        [
          -716.5,
          -2745.0,
          804.0
        ],
        [
          -747.5,
          -2745.0,
          804.0
        ],
        [
          -747.5,
          -2815.0,
          804.0
        ],
        [
          -778.5,
          -2815.0,
          804.0
        ],
        [
          -778.5,
          -2745.0,
          804.0
        ],
        [
          -778.5,
          -2675.0,
          804.0
        ],
        [
          -747.5,
          -2675.0,
          804.0
        ],
        [
          -747.5,
          -2745.0,
          804.0
        ],
        [
          -778.5,
          -2745.0,
          804.0
        ],
        [
          -833.5,
          -2675.0,
          804.0
        ],
        [
          -778.5,
          -2675.0,
          804.0
        ],
        [
          -778.5,
          -2745.0,
          804.0
        ],
        [
          -833.5,
          -2745.0,
          804.0
        ],
        [
          -833.5,
          -2745.0,
          804.0
        ],
        [
          -778.5,
          -2745.0,
          804.0
        ],
        [
          -778.5,
          -2815.0,
          804.0
        ],
        [
          -833.5,
          -2815.0,
          804.0
        ],
        [
          -700.0,
          -2675.0,
          810.0
        ],
        [
          -700.0,
          -2625.0,
          810.0
        ],
        [
          -700.0,
          -2625.0,
          826.0
        ],
        [
          -700.0,
          -2675.0,
          826.0
        ],
        [
          -640.0,
          -2862.0,
          760.0
        ],
        [
          -640.0,
          -2862.0,
          790.0
        ],
        [
          -640.0,
          -2819.0,
          790.0
        ],
        [
          -640.0,
          -2819.0,
          760.0
        ]
      ],
      "plane_distance": -804.0
    },
    {
      "tag": "CSlidingDoor piece: m4bbelev",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4bbelev",
      "offset": 1988,
      "centroid": [
        -625.0,
        -2840.0,
        797.125
      ],
      "bbox_min": [
        -636.0,
        -2854.0,
        760.0
      ],
      "bbox_max": [
        -614.0,
        -2826.0,
        810.5
      ],
      "dimensions_source": {
        "span_x": 22.0,
        "span_y": 28.0,
        "height_z": 50.5,
        "door_width": 28.0,
        "door_depth": 22.0,
        "leaf_depth": 21.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -636.0,
          -2854.0,
          809.0
        ],
        [
          -636.0,
          -2826.0,
          810.5
        ],
        [
          -636.0,
          -2854.0,
          810.5
        ],
        [
          -636.0,
          -2826.0,
          809.0
        ],
        [
          -614.0,
          -2854.0,
          809.0
        ],
        [
          -614.0,
          -2826.0,
          810.5
        ],
        [
          -614.0,
          -2854.0,
          810.5
        ],
        [
          -614.0,
          -2826.0,
          809.0
        ],
        [
          -626.0,
          -2841.0,
          760.0
        ],
        [
          -626.0,
          -2839.0,
          809.0
        ],
        [
          -626.0,
          -2841.0,
          809.0
        ],
        [
          -626.0,
          -2839.0,
          760.0
        ],
        [
          -624.0,
          -2841.0,
          760.0
        ],
        [
          -624.0,
          -2839.0,
          809.0
        ],
        [
          -624.0,
          -2841.0,
          809.0
        ],
        [
          -624.0,
          -2839.0,
          760.0
        ]
      ],
      "plane_distance": -626.0,
      "authentic_texture": "chkrooftrak_h"
    }
  ],
  "tutorial_messages": []
}